import React from 'react';

function Agb() {
  return (
    <div className="container py-4">
      <h1 className="mb-4">Allgemeine Geschäftsbedingungen</h1>
      <p className="text-muted">Futurhinos for Kids — Stand: {new Date().getFullYear()}</p>

      <section className="mb-4">
        <h2>§ 1 Geltungsbereich</h2>
        <p>
          (1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen Futurhinos for Kids,
          Astrid Schubert, Gottlieb-Daimler-Str. 20, 73614 Schorndorf (nachfolgend "Anbieter") und dem
          Vertragspartner (nachfolgend "Teilnehmer" bzw. "Erziehungsberechtigter") über die Teilnahme an Kursen,
          Workshops und sonstigen Angeboten.
        </p>
        <p>(2) Der Vertragspartner ist bei minderjährigen Teilnehmern der/die Erziehungsberechtigte.</p>
        <p>
          (3) Abweichende Bedingungen des Vertragspartners werden nicht anerkannt, es sei denn, der Anbieter
          stimmt ihrer Geltung ausdrücklich schriftlich zu.
        </p>
      </section>

      <section className="mb-4">
        <h2>§ 2 Vertragsschluss und Mitgliedschaften</h2>
        <p>
          (1) Die Anmeldung erfolgt über das Online-Anmeldeformular, per E-Mail oder persönlich vor Ort. Mit der
          Anmeldung gibt der Vertragspartner ein verbindliches Angebot zum Vertragsschluss ab.
        </p>
        <p>(2) Der Vertrag kommt mit der schriftlichen Bestätigung durch den Anbieter (per E-Mail) zustande.</p>
        <p>(3) Folgende Mitgliedschaften werden angeboten:</p>
        <ul>
          <li>
            <strong>Schnupper-Pass (49 € / Monat)</strong> — 2 feste Nachmittage pro Woche, ein kostenloser
            Schnupper-Termin vorab. Keine Mindestlaufzeit, monatlich kündbar.
          </li>
          <li>
            <strong>Entdecker-Pass (65 € / Monat)</strong> — 1 fester Nachmittag pro Woche, gilt auch in
            den Schulferien.
          </li>
          <li>
            <strong>Digital-Pilot (90 € / Monat)</strong> — 2 feste Nachmittage pro Woche, vergünstigte
            Samstags-Workshops, gilt auch in den Schulferien.
          </li>
          <li>
            <strong>Astronaut-Pass (149 € / Monat)</strong> — 5 feste Nachmittage pro Woche, vergünstigte
            Samstags-Workshops, gilt auch in den Schulferien.
          </li>
        </ul>
        <p>(4) Der gewünschte Starttermin kann frei gewählt werden.</p>
        <p>
          (5) Mit der Mitgliedschaft wird grundsätzlich ein fester Wochentag gebucht, um dem Teilnehmer einen
          festen Platz zu sichern. Kann der Teilnehmer an seinem festen Tag ausnahmsweise nicht teilnehmen,
          kann er über die Buchungsapp auf einen anderen Wochentag ausweichen, sofern dort noch freie Plätze
          verfügbar sind. Ein Anspruch auf einen freien Platz an einem anderen Wochentag besteht nicht.
        </p>
      </section>

      <section className="mb-4">
        <h2>§ 3 Zahlungsbedingungen</h2>
        <p>
          (1) Die monatlichen Beiträge für alle Mitgliedschaften sind jeweils im Voraus zum Ersten des Monats
          fällig.
        </p>
        <p>(2) Bei Vertragsschluss während eines laufenden Monats wird der Beitrag anteilig berechnet.</p>
        <p>
          (3) Die Zahlung erfolgt per SEPA-Lastschrift oder Überweisung. Bei SEPA-Lastschrift ermächtigt der
          Vertragspartner den Anbieter zum Einzug der fälligen Beträge.
        </p>
        <p>(4) Einmalzahlungen (Workshops, Feriencamps) sind vor Beginn der Leistung fällig.</p>
        <p>
          (5) Bei Zahlungsverzug ist der Anbieter berechtigt, die Teilnahme bis zum Ausgleich der offenen
          Forderungen auszusetzen.
        </p>
      </section>

      <section className="mb-4">
        <h2>§ 4 Kündigung</h2>
        <p>
          (1) Der Schnupper-Pass hat keine Mindestlaufzeit und kann jederzeit mit einer Frist von 3 Tagen zum
          Monatsende gekündigt werden.
        </p>
        <p>
          (2) Entdecker-Pass, Digital-Pilot und Astronaut-Pass haben eine Mindestlaufzeit von 6 Monaten ab
          Vertragsschluss. Danach sind sie jederzeit mit einer Frist von 3 Tagen zum Monatsende kündbar.
        </p>
        <p>(3) Die Kündigung bedarf der Textform (E-Mail an info@futurhinos.de oder schriftlich).</p>
        <p>(4) Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.</p>
      </section>

      <section className="mb-4">
        <h2>§ 5 Kurszeiten und Kursausfall</h2>
        <p>(1) Die Kurse finden zu den im Kursplan angegebenen Zeiten statt. Der aktuelle Kursplan ist online einsehbar.</p>
        <p>
          (2) An gesetzlichen Feiertagen in Baden-Württemberg finden keine Kurse statt. Ein Anspruch auf Ersatz
          oder Erstattung besteht nicht.
        </p>
        <p>(3) Während der Schulferien finden die Kurse regulär statt.</p>
        <p>(4) Der Anbieter ist berechtigt, Kurse aus wichtigem Grund abzusagen, insbesondere bei:</p>
        <ul>
          <li>Erkrankung oder Verhinderung des Kursleiters</li>
          <li>Technischen Störungen oder höherer Gewalt</li>
          <li>Behördlichen Anordnungen</li>
        </ul>
        <p>(5) Bei Kursausfall bemüht sich der Anbieter um einen Ersatztermin oder eine alternative Kursmöglichkeit.</p>
        <p>
          (6) Fallen innerhalb eines Monats mehr als 3 gebuchte Kurstermine aus, ohne dass ein Ersatz angeboten
          werden kann, wird der Monatsbeitrag anteilig erstattet.
        </p>
        <p>(7) Die Absage von Kursen wird den Teilnehmern so früh wie möglich per E-Mail oder über das Buchungssystem mitgeteilt.</p>
      </section>

      <section className="mb-4">
        <h2>§ 6 Aufsichtspflicht und Haftung</h2>
        <p>
          (1) Während der Kurszeiten übernimmt der Anbieter die Aufsichtspflicht für die teilnehmenden Kinder. Die
          Aufsichtspflicht beginnt mit der Übergabe des Kindes und endet mit dem Kursende.
        </p>
        <p>(2) Die Erziehungsberechtigten sind für den sicheren Hin- und Rückweg verantwortlich.</p>
        <p>
          (3) Die Erziehungsberechtigten sind verpflichtet, bei der Anmeldung auf gesundheitliche Einschränkungen,
          Allergien oder sonstige relevante Besonderheiten hinzuweisen.
        </p>
        <p>
          (4) Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie bei der Verletzung
          des Lebens, des Körpers oder der Gesundheit. Bei leichter Fahrlässigkeit haftet der Anbieter nur bei
          der Verletzung wesentlicher Vertragspflichten (Kardinalpflichten), deren Erfüllung die
          ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren Einhaltung der
          Vertragspartner regelmäßig vertrauen darf; in diesem Fall ist die Haftung auf den vorhersehbaren,
          vertragstypischen Schaden begrenzt.
        </p>
        <p>(5) Für mitgebrachte Gegenstände (Kleidung, Elektronik, etc.) übernimmt der Anbieter keine Haftung.</p>
        <p>
          (6) Die Teilnehmer bzw. deren Erziehungsberechtigte haften für Schäden, die durch vorsätzliches oder grob
          fahrlässiges Verhalten des Kindes verursacht werden.
        </p>
      </section>

      <section className="mb-4">
        <h2>§ 7 Verhaltensregeln</h2>
        <p>
          (1) Die Teilnehmer sind angehalten, sich respektvoll gegenüber anderen Teilnehmern, dem Personal und der
          Einrichtung zu verhalten.
        </p>
        <p>(2) Den Anweisungen des Personals ist Folge zu leisten.</p>
        <p>
          (3) Bei wiederholtem Fehlverhalten oder groben Verstößen gegen die Verhaltensregeln ist der Anbieter
          berechtigt, den Teilnehmer von der weiteren Teilnahme auszuschließen. Ein Anspruch auf Erstattung
          bereits gezahlter Beiträge besteht in diesem Fall nicht.
        </p>
      </section>

      <section className="mb-4">
        <h2>§ 8 Datenschutz</h2>
        <p>
          (1) Der Anbieter erhebt und verarbeitet personenbezogene Daten ausschließlich im Rahmen der gesetzlichen
          Bestimmungen (DSGVO, BDSG).
        </p>
        <p>
          (2) Die Einzelheiten zur Datenverarbeitung sind in der separaten{' '}
          <a href="/datenschutz">Datenschutzerklärung</a> geregelt.
        </p>
      </section>

      <section className="mb-4">
        <h2>§ 9 Widerrufsrecht für Verbraucher</h2>
        <p>(1) Verbraucher haben bei Fernabsatzverträgen ein Widerrufsrecht von 14 Tagen.</p>
        <p>(2) Die Widerrufsfrist beginnt mit dem Tag des Vertragsschlusses.</p>
        <p>
          (3) Der Widerruf ist zu richten an: Futurhinos for Kids, Astrid Schubert, Gottlieb-Daimler-Str. 20,
          73614 Schorndorf, E-Mail: info@futurhinos.de
        </p>
        <p>(4) Zur Wahrung der Widerrufsfrist genügt die rechtzeitige Absendung des Widerrufs.</p>
        <p>
          (5) Das Widerrufsrecht erlischt bei Dienstleistungen vorzeitig, wenn der Anbieter die Dienstleistung
          vollständig erbracht hat und mit der Ausführung der Dienstleistung erst begonnen hat, nachdem der
          Verbraucher ausdrücklich zugestimmt und gleichzeitig bestätigt hat, dass er sein Widerrufsrecht bei
          vollständiger Vertragserfüllung verliert.
        </p>
      </section>

      <section className="mb-4">
        <h2>§ 10 Änderungen der AGB und Preise</h2>
        <p>(1) Der Anbieter behält sich vor, diese AGB mit Wirkung für die Zukunft zu ändern.</p>
        <p>
          (2) Änderungen werden dem Vertragspartner per E-Mail mitgeteilt. Sie gelten als genehmigt, wenn der
          Vertragspartner nicht innerhalb von 4 Wochen nach Zugang der Mitteilung schriftlich widerspricht. Der
          Anbieter wird den Vertragspartner in der Änderungsmitteilung ausdrücklich auf diese Bedeutung seines
          Schweigens hinweisen.
        </p>
        <p>
          (3) Preisänderungen werden mit einer Frist von 4 Wochen zum Monatsersten angekündigt. Der
          Vertragspartner hat in diesem Fall ein Sonderkündigungsrecht zum Zeitpunkt des Inkrafttretens der
          Preisänderung.
        </p>
      </section>

      <section className="mb-4">
        <h2>§ 11 Schlussbestimmungen</h2>
        <p>(1) Es gilt das Recht der Bundesrepublik Deutschland.</p>
        <p>(2) Gerichtsstand für alle Streitigkeiten aus dem Vertragsverhältnis ist, soweit gesetzlich zulässig, Schorndorf.</p>
        <p>(3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
        <p>
          (4) Der Anbieter ist weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section className="mb-4">
        <h2>Kontakt</h2>
        <p>
          Futurhinos for Kids<br />
          Astrid Schubert<br />
          Gottlieb-Daimler-Str. 20<br />
          73614 Schorndorf<br />
          E-Mail: <a href="mailto:info@futurhinos.de">info@futurhinos.de</a><br />
          Web: <a href="https://www.futurhinos-kids.de">www.futurhinos-kids.de</a>
        </p>
      </section>
    </div>
  );
}

export default Agb;
